import { Component, OnInit, Input, EventEmitter, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { QuestionnaireService } from 'src/app/services/questionnaire/questionnaire.service';
import { QuestionOptionsConstantService } from './options-constant.service';

@Component({
  selector: 'app-create-custom-question',
  templateUrl: './create-custom-question.component.pug',
  styleUrls: ['./create-custom-question.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class CreateCustomQuestionComponent implements OnInit {
  metrics:any = [];
  @Input() selectedMetric = -2;
  @Input() questionText = '';
  @Input() isEdit = false;
  @Input() isInsights = false;
  @Input() type = 'exit';
  @Input() responseType = 'likert';
  @Input() options: any;
  @Input() hasAdditionalComments = false;
  public nextClick = new EventEmitter();
  public cancelClick = new EventEmitter();
  saveToLibrary = true;
  selectedMetricLabel = '';
  responseTypes = QuestionOptionsConstantService.questionTypes;
  questionTypes = {
    'candidate': ['TEXT_MULTI_LINE', 'RADIO_BUTTON_TOGGLE', 'DROPDOWN', 'RADIO_BUTTON'],
    'exit': ['LIKERT'],
    'pulse': ['LIKERT'],
    'employment': ['COMPETENCY', 'TEXT_MULTI_LINE', 'RADIO_BUTTON_TOGGLE', 'DROPDOWN', 'RADIO_BUTTON', 'MATRIX'],
    'reference': ['COMPETENCY', 'TEXT_MULTI_LINE', 'RADIO_BUTTON_TOGGLE', 'DROPDOWN', 'RADIO_BUTTON', 'MATRIX'],
    'character': ['COMPETENCY', 'TEXT_MULTI_LINE', 'RADIO_BUTTON_TOGGLE', 'DROPDOWN', 'RADIO_BUTTON', 'MATRIX'],
    'voluntary': ['COMPETENCY', 'TEXT_MULTI_LINE', 'RADIO_BUTTON_TOGGLE', 'DROPDOWN', 'RADIO_BUTTON', 'MATRIX'],
    'academic': ['COMPETENCY', 'TEXT_MULTI_LINE', 'RADIO_BUTTON_TOGGLE', 'DROPDOWN', 'RADIO_BUTTON', 'MATRIX'],
  };
  questionTextPlaceholder = $localize`Enter a statement`;
  formIncomplete = false;
  rtDropdownOptions: any[] = [];
  metricDropdownOptions: any[] = [];
  metricDropdownLabel = '';
  saveQuestionLabel = $localize`Save to the question library`;
  insightsCheckLabel = $localize`Display in Insights`;
  additionalCommentsLabel = $localize`Include additional comments`;

  constructor(public bsModalRef: BsModalRef,
              private questionnaireService: QuestionnaireService,
              public sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    let type = this.type=='exit' || this.type=='pulse'?this.type:'Reference';

    this.questionTypes['pulse'] = ['LIKERT_WITH_NOT_APPLICABLE'];

    if(!this.isEdit){
      this.responseType = this.questionTypes[this.type][0];
      this.options = {...this.responseTypes[this.responseType].options};
    } else {
      this.responseType = this.responseType.split('_TEXT')[0];
    }
    if (this.responseType!='LIKERT' && this.responseType!='LIKERT_WITH_NOT_APPLICABLE') {
      this.questionTextPlaceholder = $localize`Enter a question`
    };
    this.questionnaireService.getMetrics(type).subscribe(res=>{
      this.metrics = res;
      if(this.selectedMetric!=-1){
        const metricIndex = this.metrics.findIndex(m=>m.id==this.selectedMetric);
        this.selectedMetricLabel = metricIndex>-1? this.metrics[metricIndex]['name'] : '';
      } else if (this.responseType=='COMPETENCY' || this.type === 'pulse'){
        this.isInsights = true;
      }
      this.setDropdownOptions();
    });
    this.selectedMetric = -1;
  }

  clickNext(){
    // to disable button
    if (this.responseType == 'COMPETENCY' && !this.isInsights) {
      this.isInsights = true;
    }
    if (!this.questionText || (this.responseType === 'COMPETENCY' && this.selectedMetric == -1) ||
      this.formIncomplete || ((this.type=='pulse' || this.type=='exit' || this.responseType === 'COMPETENCY') && this.selectedMetric == -2)
    ) return;
    this.formIncomplete = true;
    if (this.isEdit){
      this.nextClick.emit({
        'metric': this.selectedMetric != -1 ? this.selectedMetric : null,
        'question_text': this.questionText,
        'is_measured': this.isInsights,
      });
    } else {
      this.nextClick.emit({
        'question_type': this.getQuestionType(),
        'response_type': this.getResponseType(),
        'metric': (this.selectedMetric != -1 && this.selectedMetric != -2) ? this.selectedMetric : null,
        'question_text': this.questionText,
        'is_measured': this.isInsights,
        'is_hidden': !this.saveToLibrary,
        'is_verified': false,
        'is_custom': true,
        'options': this.options,
        'question_ref_category': this.selectedMetric != -1 ? QuestionOptionsConstantService.metricsRefMapping[this.selectedMetricLabel] : null,
        'has_additional_comments': (this.responseType.toLowerCase() === 'likert' || this.responseType.toLowerCase() === 'likert_with_not_applicable') ? this.hasAdditionalComments : false,
      });
    }
    this.bsModalRef.hide();
  }

  setDropdownOptions(): void {
    this.metricDropdownOptions = [];
    if (!this.rtDropdownOptions.length) {
      for (let i in this.questionTypes[this.type]) {
        let rt = this.questionTypes[this.type][i];
        this.rtDropdownOptions.push({'key': rt, 'value': this.responseTypes[rt].label});
      }
    }

    if (this.type == 'exit' && this.selectedMetric == -2) {
      this.metricDropdownLabel = $localize`Select a metric`;
    } else if(this.type == 'pulse' && this.selectedMetric == -2) {
      this.metricDropdownLabel = $localize`Select a metric (optional)`;
    } else if(this.type == 'pulse' && this.selectedMetric == -1) {
      this.metricDropdownLabel = $localize`Select a metric (optional)`;
    } else if (this.type == 'exit' && this.selectedMetric == -1) {
      this.metricDropdownLabel = $localize`None`;
    } else if(this.type!='exit' && this.type!='pulse' && this.responseType != 'COMPETENCY' && this.selectedMetric <= -1) {
      this.metricDropdownLabel = $localize`No category`;
    } else if(this.type!='exit' && this.type != 'pulse' && this.responseType == 'COMPETENCY' && this.selectedMetric <= -1) {
      this.metricDropdownLabel = $localize`Select a category`;
    } else if (this.selectedMetric > -1){
      this.metricDropdownLabel = this.selectedMetricLabel;
    }

    this.metrics.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
    if (this.type=='exit' || this.type=='pulse' || (this.type!='exit' && this.type !='pulse' && this.responseType != 'COMPETENCY')) {
      if (this.type == 'exit') {
        this.metricDropdownOptions.push({key: -1, value: 'None'});
      } else if (this.type != 'pulse') {
        this.metricDropdownOptions.push({key: -1, value: 'No category'});
      }
    }
    for (let i in this.metrics) {
      this.metricDropdownOptions.push({'key': this.metrics[i].name, 'value': this.metrics[i].name, 'options': this.metrics[i]});
    }
  }
  getQuestionType(): String{
    if (this.type=='exit'||this.type=='candidate'||this.type=='pulse'){
      return this.type
    }
    return 'reference';
  }

  getResponseType(): String{
    if (this.responseType=='TEXT_MULTI_LINE'){
      return this.options.single_line ? 'TEXT_SINGLE_LINE' : 'TEXT_MULTI_LINE';
    }
    let response_type = this.responseTypes[this.responseType].value;
    if (this.responseType=='MATRIX') {
      return response_type;
    }
    if (this.options.options.some(option => option.comments_required)){
      response_type = response_type + '_TEXT';
    }
    return response_type;
  }

  changeType(rt){
    rt = rt['key'];
    if(this.responseType==rt){
      return;
    }
    this.responseType = rt;
    this.options = JSON.parse(JSON.stringify(this.responseTypes[this.responseType].options));
    this.questionText = '';
    if(['COMPETENCY', 'TEXT_MULTI_LINE', 'RADIO_BUTTON_TOGGLE'].includes(this.responseType)) {
      // These question types do not have a custom disableSave method
      this.formIncomplete = false;
    }
    if (this.responseType=='COMPETENCY'){
      this.isInsights = true;
    } else{
      this.isInsights = false;
    }
    this.selectedMetricLabel = '';
    this.selectedMetric = -1;
    if (this.responseType=='MATRIX') {
      this.questionTextPlaceholder = $localize`Enter a title`
    } else if (this.responseType!='LIKERT' && this.responseType!='LIKERT_WITH_NOT_APPLICABLE') {
      this.questionTextPlaceholder = $localize`Enter a question`
    };
    this.setDropdownOptions();
  }

  selectMetric(metric){
    if(metric['key'] < -2) return;
    if(metric['key'] == -1){
      this.selectedMetric = metric['key'];
      this.isInsights = false;
      return;
    }
    this.selectedMetricLabel = metric['key'];
    this.selectedMetric = metric['options'].id;
    if(this.type=='exit' || this.type=='pulse'){
      this.isInsights = true;
    }
  }

  clickCancel(){
    this.cancelClick.emit();
    this.bsModalRef.hide();
  }

  isFormIncomplete(event){
    console.log(event);
    this.formIncomplete = event;
  }

  isInsightsChange(event) {
    this.isInsights = !this.isInsights;
  }

  saveToLibraryChange(event) {
    this.saveToLibrary = !this.saveToLibrary;
  }

  additionalCommentsChange(event) {
    this.hasAdditionalComments = !this.hasAdditionalComments;
  }
}
